import Vue from 'vue'
import VueRouter from 'vue-router'
import home from './home'
import system from './system'
import login from './login'
import register from './register'
import recovery from './recovery'
import resetPassword from './reset-password'
import consent from './consent'
import error from './error'
import logout from './logout'
import postLogout from './post-logout'
import manage from './manage'
import error2 from './error2'

Vue.use(VueRouter)

const routes = [
  ...system,
  ...login,
  ...register,
  ...recovery,
  ...resetPassword,
  ...consent,
  ...error,
  ...error2,
  ...logout,
  ...postLogout,
  ...manage,
  ...home,
  {
    path: '*',
    redirect: '/page404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
